import React from "react";

export default function Data({ data }) {
  return <>{data?.custom && data?.custom()}</>;
}
